import React from 'react';

import ConfigService from "../../../Services/api/Config";
import classNames from "classnames";

class Button extends React.PureComponent {

  render() {
    const { className, onClick, children, btnText, display = true, disabled } = this.props;

    if (!display) {
      return null;
    }

    const styleButton = {
      'backgroundColor': ConfigService.getColor('secondaryColor'),
    };

    if (className) {
      if (className.includes('Button_Disabled')){
        styleButton['backgroundColor'] = ConfigService.getColor('tertiaryColor', 0.5);
      }
      else if (className.includes('Button_Cancel')){
        styleButton['backgroundColor'] = ConfigService.getColor('tertiaryColor');
      }
      else if (className.includes('Button_Delete')) {
        styleButton['backgroundColor'] = ConfigService.getColor('errorColor');
      }
      else if (className.includes('Button_Black')) {
        styleButton['backgroundColor'] = ConfigService.getColor('primaryColor');
      }
      else if (className.includes('Button_Orange')) {
        styleButton['backgroundColor'] = ConfigService.getColor('warningColor');
      }
      else if (className.includes('Button_Clear')) {
        styleButton['backgroundColor'] = ConfigService.getColor('tertiaryColor', 0.6);
      }
      else if (className.includes('Button_Collapsable')) {
        styleButton['backgroundColor'] = 'transparent';
        styleButton['borderColor'] = ConfigService.getColor('primaryColor');
        styleButton['color'] = ConfigService.getColor('primaryColor');
      }
    }
    return (
      <button 
        type='button' 
        className={ classNames('Button', className) }
        onClick={ onClick } style={ styleButton }
        disabled = {disabled}
      >
        {btnText && btnText}
        {children}
      </button>
    );
  }
}

export default Button;